export const RESTORE_CERTIFICATION = 'RESTORE_CERTIFICATION';
export const UPDATE_CERTIFICATION_PROPERTY = 'UPDATE_CERTIFICATION_PROPERTY';
export const CERTIFICATION_FOR_EDIT_LOADED = 'CERTIFICATION_FOR_EDIT_LOADED';
export const SET_LOADING = 'SET_LOADING';
export const SET_CERTIFICATION_VALIDATION_ERRORS = 'SET_CERTIFICATION_VALIDATION_ERRORS';
export const SET_SECTIONS_EDIT_STATE = 'SET_SECTIONS_EDIT_STATE';
